let getRequestId = () => undefined;
if (typeof window === "undefined") {
  const rTracer = require("cls-rtracer");
  getRequestId = () => rTracer.id();
}

export default getRequestId;
